module.exports = __webpack_public_path__ + "img/boxing-gloves.96da855c.gif";